import { render } from "./MaintenancePage.vue?vue&type=template&id=46b77c6c"
import script from "./MaintenancePage.vue?vue&type=script&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__